import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { selector } from "../../../api";
import { accountingCRUD } from "../../../actions/accounting";
import { TableShared } from "../../../shared";
import { char } from "../../../utils";
import {
  Badge,
  Button,
  ConfigProvider,
  Dropdown,
  Space,
  notification,
} from "antd";
import {
  PlusCircleOutlined,
  MoreOutlined,
  DeleteOutlined,
  EyeOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { LoanBoardAdd } from "./add";

const items = [
  {
    label: "Edit",
    key: "edit",
    icon: <EditOutlined />,
  },
  {
    label: "View",
    key: "view",
    icon: <EyeOutlined />,
  },
  {
    label: "Delete",
    key: "delete",
    icon: <DeleteOutlined />,
  },
];

export const LoanBoardContent = () => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [postsPerPage, setePostPerPage] = useState(10);
  const [nextPage, setNextPage] = useState(0);
  const [value, setValue] = useState("");
  const [index, setIndex] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [sortType, setSortType] = useState("");

  const [api, contextHolder] = notification.useNotification();

  const user = selector.User();

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      accountingCRUD
        .loadLoanBoard(
          postsPerPage,
          nextPage,
          value,
          sortType === "desc" ? "-" + sortColumn : sortColumn
        )
        .then((resp) => {
          setData(resp.data.results);
          setCount(resp.data.count);
        })
        .catch((error) => {
          api.error({
            message: error.message,
            description:
              "Oops! It looks like you're not connected to the network. Please check your network connectivity and try again",
            placement: "topRight",
          });
        })
        .finally(() => {
          setLoading(false);
        });
    }, 500);
  }, [page, postsPerPage, value, index, nextPage, sortColumn, sortType]);

  const defaultColumns = [
    {
      key: "sn",
      title: "#",
      dataIndex: "sn",
      fixed: true,
      width: 70,
    },
    {
      key: "acronym",
      title: "Abbreviation",
      dataIndex: "acronym",
      sortable: true,
      width: 120,
    },
    {
      key: "name",
      title: "Name",
      dataIndex: "name",
      sortable: true,
      width: 350,
    },
    {
      key: "address",
      title: "Address",
      dataIndex: "address",
      sortable: true,
      flexGrow: 1,
    },
    {
      key: "phone_number",
      title: "Phone Number",
      dataIndex: "phone_number",
      sortable: true,
      flexGrow: 1,
    },
    {
      key: "description",
      title: "Description",
      dataIndex: "description",
      sortable: true,
      flexGrow: 1,
    },
    {
      key: "status",
      title: "Status",
      dataIndex: "status",
      sortable: true,
      width: 150,
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 100,
      render: (record) => (
        <Dropdown
          menu={{
            items,
            onClick: (event) => {
              switch (event.key) {
                case "1":
                  setOpen(true);
                  break;
                default:
              }
            },
          }}
          placement="bottomRight"
          arrow={{ pointAtCenter: true }}
          trigger={["click"]}
        >
          <Space>
            <Button type="dashed" icon={<MoreOutlined />} size={"middle"} />
          </Space>
        </Dropdown>
      ),
    },
  ];

  const dataItem = data?.map((dt, i) => ({
    id: dt.id,
    sn: i + 1,
    acronym: dt.acronym ? char.toUpperCase(dt.acronym) : "N/A",
    name: dt.name ? char.toTitleCase(dt.name) : "N/A",
    address: dt.address ? char.toTitleCase(dt.address) : "N/A",
    phone_number: dt.phone_number ? dt.phone_number : "N/A",
    description: dt.description ? char.toUpperCaseFirst(dt.description) : "N/A",
    status: dt.is_active ? (
      <span class="badge badge-soft-success badge-border">
        {char.toTitleCase("active")}
      </span>
    ) : (
      <span class="badge badge-soft-danger badge-border">
        {char.toTitleCase("inactive")}
      </span>
    ),
  }));

  const button = (
    <button
      className="btn btn-primary bg-gradient btn-border"
      onClick={() => setOpen(true)}
    >
      <span className="bi bi-plus-circle la-lg"></span> &nbsp; New Board
    </button>
  );

  return (
    <>
      {contextHolder}
      <LoanBoardAdd
        open={open}
        setOpen={setOpen}
        index={index}
        setIndex={setIndex}
      />
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-12">
            <p className="h6 fs-18 fw-bold text-dark">Loan Board</p>
          </div>
          <hr className="mt-3" />
        </div>
        <TableShared
          setOpen={setOpen}
          loading={loading}
          data={dataItem}
          setData={setData}
          page={page}
          setPage={setPage}
          count={count}
          postsPerPage={postsPerPage}
          setePostPerPage={setePostPerPage}
          setNextPage={setNextPage}
          value={value}
          setValue={setValue}
          defaultColumns={defaultColumns}
          button={button}
          link={"#"}
          showButton={true}
          sortColumn={sortColumn}
          setSortColumn={setSortColumn}
          sortType={sortType}
          setSortType={setSortType}
          setLoading={setLoading}
        />
      </div>
    </>
  );
};
